import { HttpResponse } from '@angular/common/http';
import { AcceptedError } from './acceptedError';

// Note the currently slightly weird pattern. Each place we want to do the mapping, this function gets
// *called* and then it returns a function to do the mapping that has the correct interval set.
//
// There could also be a default mapper with a default retry delay to accomplish the same thing.
export function mapAccepted(retryDelay: number = 20 * 1000) {
  return (result: HttpResponse<unknown>) => {
    if (result.status === 202) {
      throw new AcceptedError(retryDelay);
    }

    return result.body;
  };
}
